export const DEFAULT_HOMEROOM_SUBJECTS = [
  "中國語文",
  "英國語文",
  "數學",
  "公民、經濟與社會",
  "體育",
  "宗教教育",
  "科學",
  "中國歷史",
  "世界歷史",
  "普通話",
  "地理",
] as const;

export const HOMEROOM_HOMEWORK_TASK_TYPES = [
  { value: "exercise", label: "作業" },
  { value: "worksheet", label: "工作紙" },
  { value: "notes", label: "筆記" },
  { value: "classwork", label: "堂課" },
  { value: "revision", label: "溫習／默書" },
  { value: "replySlip", label: "回條" },
  { value: "other", label: "其他" },
] as const;

export function homeroomHomeworkTaskLabel(value?: string) {
  return HOMEROOM_HOMEWORK_TASK_TYPES.find((item) => item.value === value)?.label || "作業";
}

export const DEFAULT_CLASS_DUTIES = [
  "班長（一）",
  "班長（二）",
  "風紀",
  "學藝",
  "康樂",
  "總務",
  "清潔",
  "膳長",
] as const;

import type { AttendanceRecord, AttendanceStatus, HomeroomHomeworkRecord } from "./types.js";

export function attendanceStatus(exceptions: Record<string, "late" | "absent">, studentId: string): AttendanceStatus {
  return exceptions[studentId] || "present";
}

export function nextAttendanceStatus(status: AttendanceStatus): AttendanceStatus {
  return status === "present" ? "late" : status === "late" ? "absent" : "present";
}

export function attendanceCounts(
  studentIds: string[],
  exceptions: Record<string, "late" | "absent">,
): Record<AttendanceStatus, number> {
  const counts = { present: 0, late: 0, absent: 0 };
  for (const studentId of studentIds) counts[attendanceStatus(exceptions, studentId)] += 1;
  return counts;
}

export function studentAttendanceHistory(records: AttendanceRecord[], studentId: string) {
  return records
    .filter((record) => record.studentIds.includes(studentId))
    .map((record) => ({ date: record.date, status: attendanceStatus(record.exceptions, studentId) }))
    .sort((a, b) => b.date.localeCompare(a.date));
}

export function studentMissingHomeworkHistory(records: HomeroomHomeworkRecord[], studentId: string) {
  return records
    .filter((record) => record.missingStudentIds.includes(studentId))
    .map((record) => ({
      date: record.date,
      subject: record.subject,
      taskType: record.taskType,
      taskLabel: homeroomHomeworkTaskLabel(record.taskType),
      taskDetail: record.taskDetail || "",
    }))
    .sort(
      (a, b) =>
        b.date.localeCompare(a.date) ||
        a.subject.localeCompare(b.subject, "zh-HK") ||
        a.taskDetail.localeCompare(b.taskDetail, "zh-HK"),
    );
}
